import React, { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import AnimationScreen from '../components/AnimationScreen';
import ProgressBar from '../components/ProgressBar';
import NavigationBar from '../components/NavigationBar';
import OptionList from '../components/OptionList';
import { OptionItem, PageData } from '../types/types';

const Start: React.FC = () => {
	const { title, progress, content } = useLoaderData() as PageData;
	const [ nextPage, setNextPage ] = useState<string | undefined>();
	const [ redirect, setRedirect ] = useState<OptionItem | undefined>();

	const selectNextStep = ( option: OptionItem ) => {
		const { path, url } = option;

		if ( ! url ) {
			setNextPage( path );
			setRedirect( undefined );
		} else {
			setNextPage( url );
			setRedirect( option );
		}
	};

	return (
		<AnimationScreen>
			<ProgressBar progress={progress} />
			<h3>{title}</h3>
			{content.options && (
				<OptionList options={content.options} onSelect={selectNextStep} />
			)}
			<NavigationBar next={nextPage} first={true} redirect={redirect} />
		</AnimationScreen>
	);
};

export default Start;
